export default __webpack_public_path__ + "static/media/example-src-bad-2.610c5b22.webp";